import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-bank-details-report',
  templateUrl: './employee-bank-details-report.component.html',
  styleUrls: ['./employee-bank-details-report.component.scss']
})
export class EmployeeBankDetailsReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
